module.exports = __webpack_public_path__ + "static/media/3.95dbf356.wav";